import React from 'react';
import PropTypes from 'prop-types';

import './index.css';

const TextOnlyCard = ({ data, className, ...other }) => {
	if (!data) return null;

	const renderHeading = (classes) => (
		<div
			dangerouslySetInnerHTML={{ __html: data.heading }}
			className={`stan-heading ${classes || ''}`}
		/>
	);

	const renderSubheading = (classes) => (
		<div
			dangerouslySetInnerHTML={{ __html: data.subheading }}
			className={`stan-subhead ${classes || ''}`}
		/>
	);

	const renderDescription = (classes) => (
		<div
			dangerouslySetInnerHTML={{ __html: data.description }}
			className={`stan-desc ${classes || ''}`}
		/>
	);

	return (
		<div
			className={`standard h-full bg-primary ${className || ''}`}
			{...other}
		>
			<>
				<div className='mx-auto flex h-full flex-col justify-center text-center'>
					{data.heading && renderHeading('font-bold text-[28px] lg:text-[36px] leading-snug')}
					{data.subheading && renderSubheading('font-bold text-[84px] lg:text-[108px] leading-none')}
					{data.description && renderDescription('text-[20px] lg:text-[24px]')}
				</div>
			</>
		</div>
	);
};

TextOnlyCard.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default TextOnlyCard;
